import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

// 2026-05-06 H-8 — OperationsGuard added across student admin routes.
// Operations roles only (super_admin / tenant_admin / tenant_manager).
// Backend already enforces; this is route-level defense-in-depth.
export const StudentsRoutes: Route[] = [
  {
    path: "students",
    loadComponent: () =>
      import("../../Feature/students/pages/students-list/students-list.component").then(
        (mod) => mod.StudentsListComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
  {
    path: "students/:id/student-info/wallet",
    loadComponent: () =>
      import("../../Feature/students/pages/student-wallet/student-wallet.component").then(
        (mod) => mod.StudentWalletComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
  {
    path: "students/:id/student-info",
    loadComponent: () =>
      import("../../Feature/students/pages/student-profile/student-profile.component").then(
        (mod) => mod.StudentProfileComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
